import log from "loglevel";
import CqrsClient from "./cqrsClient";
import { StoreId } from "./store.service";

const cqrsClient = new CqrsClient({ baseUri: "/umbraco/api/Store/" });

const storage = window.localStorage;
const session = window.sessionStorage;

const keys = {
    DELIVERY_POSTCODE: "DELIVERY_POSTCODE",
    CRUSHING_PLANT: "CRUSHING_PLANT"
}

export const GetPostcode = () => storage.getItem(keys.DELIVERY_POSTCODE);

export const SavePostcode = postcode => storage.setItem(keys.DELIVERY_POSTCODE, postcode);

export const GetClosestCrushingPlant = (productReference, postcode = null) => {
    postcode = postcode || GetPostcode();
    if (!postcode) {
        throw `Postcode not supplied, and none exists in localstorage`;
    }
    let storageKey = `${keys.CRUSHING_PLANT}_${productReference}_${postcode}`;
    let plantString = session.getItem(storageKey);
    if (plantString !== null) {
        let plant = JSON.parse(plantString);
        log.debug("Crushing plant is cached in session.", { plant });
        return new Promise((resolve, reject) => {
            resolve(plant);
        });
    }
    log.debug("Fetching closest crushing plant.");
    let query = cqrsClient.query({
        $type: "SkoltHolding.Core.Models.Queries.GetCrushingPlantForPostcodeQuery, SkoltHolding.Core",
        storeId: StoreId,
        postCode: postcode,
        productReference: productReference
    }).then((res) => {
        log.debug("Plant fetched, caching", res)
        session.setItem(storageKey, JSON.stringify(res));
        return res;
    });
    return query;
}

export default {
    SavePostcode,
    GetPostcode,
    GetClosestCrushingPlant
}